import { render, staticRenderFns } from "./MessagesNavbar.vue?vue&type=template&id=a214ffce&scoped=true&"
import script from "./MessagesNavbar.vue?vue&type=script&lang=js&"
export * from "./MessagesNavbar.vue?vue&type=script&lang=js&"
import style0 from "./MessagesNavbar.vue?vue&type=style&index=0&id=a214ffce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a214ffce",
  null
  
)

export default component.exports